import { Component } from '@angular/core';
import { DocumentModel } from '../document.model';
import { IDocumentViewData } from '../document-view/document-view.component';
import { ItemViewContainerBase } from '@fi-app/core/item-view-container-base';

@Component({
    selector: 'fi-document-view-container',
    template: ` <fi-document-view [data]="documentViewData" [document]="document"></fi-document-view> `,
    styleUrls: ['./document-view-container.component.scss'],
    standalone: false,
})
export class DocumentViewContainerComponent extends ItemViewContainerBase {
    documentViewData: IDocumentViewData;
    document: DocumentModel;
}
